import { render, staticRenderFns } from "./SleepViewVideo.vue?vue&type=template&id=224fc9f1&scoped=true"
import script from "./SleepViewVideo.vue?vue&type=script&lang=js"
export * from "./SleepViewVideo.vue?vue&type=script&lang=js"
import style0 from "./SleepViewVideo.vue?vue&type=style&index=0&id=224fc9f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224fc9f1",
  null
  
)

export default component.exports